/**
 * RowElement — F12.H T12.H.3.
 *
 * Wiersz — kontener poziomy (flex), dzieci wyrównane w jednej linii.
 * Użycie: grupowanie 2-3 pól na jednym rzędzie poza standardową
 * siatką sekcji (np. „Imię + Nazwisko" w jednym wierszu).
 *
 * Settings: { gap?: 'sm'|'md'|'lg', align?: 'start'|'center'|'end',
 *             wrap?: boolean }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const GAP_CLASS: Record<string, string> = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4',
};

const ALIGN_CLASS: Record<string, string> = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
};

export const RowElement: LayoutElementDefinition = {
  type: 'row',
  category: 'kontenery',
  isContainer: true,
  label: 'Wiersz',
  icon: 'Rows',
  defaultSettings: () => ({
    gap: 'md',
    align: 'start',
    wrap: false,
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      gap?: 'sm' | 'md' | 'lg';
      align?: 'start' | 'center' | 'end';
      wrap?: boolean;
    };
    const gapCls = GAP_CLASS[settings.gap ?? 'md'] ?? 'gap-3';
    const alignCls = ALIGN_CLASS[settings.align ?? 'start'] ?? 'items-start';
    const wrapCls = settings.wrap ? 'flex-wrap' : '';
    const isBuilder = mode === 'builder';

    return (
      <div
        className={`flex ${gapCls} ${alignCls} ${wrapCls} ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition rounded p-1' : ''}`}
        data-testid={`row-element-${element.id}`}
        data-element-type="row"
      >
        {children.length > 0 ? (
          children.map((child, idx) => (
            <div key={idx} className="flex-1 min-w-0">
              {child}
            </div>
          ))
        ) : isBuilder ? (
          <div className="flex-1 rounded border-2 border-dashed border-border-primary py-3 text-center text-xs text-text-muted">
            Przeciągnij elementy obok siebie
          </div>
        ) : null}
      </div>
    );
  },
};
